const headers = ['currencies.symbol', 'label.name'];

export default headers;
